import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  ListItemText,
  Typography,
  Box,
} from '@mui/material';
import { CameraSet } from '../../types/canvision.types';

interface SetSelectorProps {
  sets: CameraSet[];
  selectedSetId: number | null;
  onSetChange: (setId: number | null) => void;
  disabled?: boolean;
}

function SetSelector({ sets, selectedSetId, onSetChange, disabled }: SetSelectorProps) {
  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel id="camera-set-selector-label">Camera Set</InputLabel>
      <Select
        labelId="camera-set-selector-label"
        value={selectedSetId ?? ''}
        onChange={(e) => {
          const value = e.target.value;
          onSetChange(value === '' ? null : (value as number));
        }}
        label="Camera Set"
        disabled={disabled}
      >
        <MenuItem value="">
          <ListItemText
            primary="All Cameras"
            secondary="Show all available cameras"
          />
        </MenuItem>
        {sets.map((set) => (
          <MenuItem key={set.id} value={set.id}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
              <ListItemText
                primary={set.name}
                secondary={set.description || undefined}
              />
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ ml: 2, whiteSpace: 'nowrap' }}
              >
                {set.cameras?.length || 0} cameras
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SetSelector;
